import React from 'react';
import FixedDrivers from './Fields/FixedDrivers';

const Section6 = ({ form, disabled }) => {
  return (
    <div className="sixSection">
      <div className="border-emmit"></div>
      <div className="aHeight-3"></div>
      <div className="treeColWrap">
        <FixedDrivers form={form} disabled={disabled} />
      </div>
    </div>
  );
};

export default Section6;
